var map = {
	"./busd.svg": 1992,
	"./crypto-pending.png": 1993,
	"./crypto-reject.png": 1994,
	"./crypto-success.png": 1995,
	"./direpay.svg": 1996,
	"./trx.svg": 1997,
	"./usdc.svg": 1998,
	"./usdt.svg": 1999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;